import { render, staticRenderFns } from "./dictDetail.vue?vue&type=template&id=ec42f9d0&scoped=true"
import script from "./dictDetail.vue?vue&type=script&lang=js"
export * from "./dictDetail.vue?vue&type=script&lang=js"
import style0 from "./dictDetail.vue?vue&type=style&index=0&id=ec42f9d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec42f9d0",
  null
  
)

export default component.exports